import type { InspectionReportStatus } from '@jobos/shared';
import { cn } from '@/lib/utils';

export interface InspectionReportStatusBadgeProps {
  status: InspectionReportStatus;
  /** Rendered beside "Sent" when present. Ignored for any other status. */
  sentAt?: string | null;
  className?: string;
}

const STYLES: Record<InspectionReportStatus, string> = {
  draft: 'bg-gray-100 text-gray-700',
  // Nothing sets `final`, but a row carrying it must still render as something
  // rather than an unstyled blank.
  final: 'bg-blue-100 text-blue-800',
  sent: 'bg-green-100 text-green-800',
};

const LABELS: Record<InspectionReportStatus, string> = {
  draft: 'Draft',
  final: 'Final',
  sent: 'Sent',
};

export function InspectionReportStatusBadge({
  status,
  sentAt,
  className,
}: InspectionReportStatusBadgeProps) {
  const date = status === 'sent' && sentAt ? new Date(sentAt) : null;
  const label =
    date && !Number.isNaN(date.getTime())
      ? `Sent ${date.toLocaleDateString(undefined, { day: 'numeric', month: 'short' })}`
      : LABELS[status];

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded px-2 py-0.5 text-xs font-medium',
        STYLES[status],
        className,
      )}
    >
      {label}
    </span>
  );
}
